module.exports = __webpack_public_path__ + "media/photographerOnboarding/mobile-bg-4b9f0bbf.png";